import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const TermsPage = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="terms">
      <h2>Terms of Service</h2>

      <h3>Date: 2023-07-21</h3>
      <p>&zwj;</p>
      <p>
        Welcome to www.hashflow.com, a website-hosted user interface (the
        “Interface” or “App”) provided by the Hashflow, an exempted foundation
        company incorporated in the Cayman Islands,, the DAO (as defined below)
        and their affiliates. (“Hashflow”, “we”, “our” or “us”). The Hashflow
        Foundation does not use the App to offer or sell digital assets nor are
        we an agent for any user that offers or sells digital assets. The
        Interface provides access to a decentralized protocol on several
        blockchains that allows (i) users to trade certain digital assets, (ii)
        suppliers of digital assets to make markets in such assets and (iii)
        suppliers and borrowers of certain digital assets to participate in
        autonomous interest rate markets (the “Protocol”).
      </p>
      <p>
        This Terms of Service Agreement (the “Agreement” or “Terms”) explains
        the terms and conditions by which you may access and use the Protocol.
        You must read this Agreement carefully. By accessing or using the
        Protocol, you signify that you have read, understand, and agree to be
        bound by this Agreement in its entirety. If you do not agree, you are
        not authorized to access or use the Interface or the Protocol.
      </p>
      <p>
        <strong>
          Additionally, you acknowledge and agree that entities that are
          affiliated or under common control with us, either for profit or not
          for profit, may make markets in digital assets through the
          Interface.&nbsp; In such cases, users may be given quotes for digital
          assets from such affiliated entities.
        </strong>
      </p>
      <p>
        <strong>
          Finally, you agree that if you use the Protocol to make markets you
          agree to additional terms and conditions as detailed{" "}
        </strong>
        <a href="https://www.hashflow.com/mm-terms">
          <strong>HERE</strong>
        </a>
        <strong>.&nbsp;</strong>
      </p>
      <p>
        <strong>
          NOTICE: This Agreement contains important information, including a
          binding arbitration provision and a class action waiver, both of which
          impact your rights as to how disputes are resolved. The Protocol is
          only available to you, and you should only access the Protocol if you
          agree completely with these Terms.
        </strong>
      </p>
      <p>
        <strong>
          ARBITRATION NOTICE: THESE TERMS CONTAIN AN ARBITRATION CLAUSE BELOW.
          YOU AND WE AGREE THAT ANY DISPUTES RELATING TO THE SERVICES WILL BE
          RESOLVED BY MANDATORY BINDING ARBITRATION, AND YOU WAIVE ANY RIGHT TO
          A TRIAL BY JURY OR TO PARTICIPATE IN A CLASS-ACTION LAWSUIT OR
          CLASS-WIDE ARBITRATION. You are entering into a binding Agreement.
        </strong>
      </p>
      <p>&zwj;</p>
      <h3>
        <strong>DEFINITIONS</strong>
      </h3>
      <p>In these Terms:</p>
      <p>
        “Art” means any art, design, wording and drawings that are associated
        with an NFT that you Own;
      </p>
      <p>
        “Business Day” means any day except a Saturday or a Sunday or other
        public holiday
      </p>
      <p>
        “Claim” includes a claim, notice, demand, action, proceeding,
        litigation, investigation, however arising whether present,
        unascertained, immediate, future or contingent, whether based in
        contract, tort or statute and whether involving a third party or a party
        to these Terms and where and to the extent the context permits, includes
        all associated Loss;
      </p>
      <p>
        “DAO” means our decentralized community of autonomous users, comprised
        of holders of the HFT token, who control certain governance rights as
        such rights are progressively transferred to them by the Foundation and
        who will eventually govern all aspects of the Protocol.
      </p>
      <p>
        “Digital Currency” means a cryptographically secured virtual currency or
        virtual asset which we identify as an acceptable means of payment or
        transacting with us;
      </p>
      <p>
        “Digital Wallet” means the applicable “Metamask” location, public key or
        wallet address, account or storage device which we choose to support for
        the delivery of the NFTs provided by us;
      </p>
      <p>
        “Privacy Policy” means the privacy policy on the Protocol which can be
        located at{" "}
        <a href="http://hashflow.com/privacy">hashflow.com/privacy</a>
        or as may be varied from time to time.
      </p>
      <p>
        “Purchase Price” means the amount advertised for the purchase (or
        pre-purchase) of any NFT or bundle containing an NFT, which may be
        denominated in a Digital Currency;
      </p>
      <p>
        “Intellectual Property” means all present and future intellectual and
        industrial property rights conferred by statute, at common law or in
        equity and wherever existing, including:
      </p>
      <ol>
        <li>
          patents, inventions, discoveries, designs, copyright, trade marks,
          trading styles, trade names, brand names, business names, product
          names, domain names or rights in designs, art, images, drawings,
          processes, know how, methodologies, product names, trade secrets and
          any other rights subsisting in the results of intellectual effort in
          any field, whether or not registered or capable of registration and
          all current and future registered and unregistered rights, development
          or enhancement of the intellectual property owned by us or by our
          licensors;&nbsp;
        </li>
        <li>
          any application or right to apply for registration of any of the
          rights detailed in this section or other rights of a similar nature
          arising or capable of arising under statute or at common law anywhere
          in the world;&nbsp;
        </li>
        <li>
          other intellectual property as defined in Article 2 of the Convention
          Establishing the World Intellectual Property Organization 1967;&nbsp;
        </li>
        <li>
          any registration of any of the rights detailed in this section or any
          registration of any application referred to in this section;&nbsp;
        </li>
        <li>
          and all renewals and extensions of the rights detailed in this
          section;
        </li>
      </ol>
      <p>
        “Loss” includes and loss, damage, cost, charge, liability or expense
        (including legal costs and expenses);
      </p>
      <p>
        “Marketplace” means a software platform or software (including a
        Blockchain digital wallet) which permits the transfer, purchase or sale
        of an NFT, provided that the Marketplace at all times cryptographically
        verifies the NFT owner’s right to Own the NFT.
      </p>
      <p>
        “NFT” means a non-fungible token issued by either Hashflow or its
        affiliate Hashflow Labs LLC for use in the Hashverse.
      </p>
      <p>
        “NFT Terms” mean the terms and conditions of these Terms that
        specifically relate to the purchase and ownership of NFTs in particular
        clauses 20-33.
      </p>
      <p>
        “Own” means, with respect to an NFT, any NFT we have issued where proof
        of ownership is recorded on a blockchain system and you control the
        private key associated with a Digital Wallet to which the NFT is
        associated or located;
      </p>
      <p>
        “Personnel” means any employee, contractor, subcontractor, agent,
        partner, shareholder, ultimate beneficial owner, director or officer of
        a party;
      </p>
      <p>“Procure” means to obtain;</p>
      <p>
        “Your Jurisdiction” means the country or state where you are ordinarily
        resident or from which you enter into any agreement with us.
      </p>
      <h3>
        <strong>1. Modification of this Agreement</strong>
      </h3>
      <p>
        We, or in the future, a decentralized governing body, may, in our sole
        discretion, modify this Agreement or any services associated with this
        Agreement from time to time. If we make any modifications, we will
        notify you by updating the date at the top of the Agreement and by
        maintaining a current version of the Agreement at
        www.hashflow.com/terms. All modifications will be effective when they
        are posted, and your continued use of the Protocol will serve as
        confirmation of your acceptance of those modifications. If you do not
        agree with any modifications to this Agreement, you must immediately
        stop accessing and using the Protocol.
      </p>
      <h3>
        <strong>2. Eligibility &amp; Fees</strong>
      </h3>
      <p>
        To access or use the Protocol, you must be able to form a legally
        binding contract with us. Accordingly, you represent that you are at
        least the age of majority in Your jurisdiction and have the full right,
        power, and authority to enter into and comply with the terms and
        conditions of this Agreement on behalf of yourself and any company or
        legal entity for which you may access or use the Protocol. You further
        represent that you are not (a) the subject of economic or trade
        sanctions administered or enforced by any governmental authority or
        otherwise designated on any list prohibited or restricted parties
        including the US Department of Treasury Sanctions list (
        <a href="https://www.treasury.gov/resource-center/sanctions/Programs/Pages/Programs.aspx">
          https://www.treasury.gov/resource-center/sanctions/Programs/Pages/Programs.aspx
        </a>
        ) or (b) named on the Office of Foreign Asset Control’s list of
        Specially Designated Nationals and Blocked Persons (“SDN List”)
        currently found at{" "}
        <a href="https://www.treasury.gov/resource-center/sanctions/SDN-List/Pages/default.aspx">
          https://www.treasury.gov/resource-center/sanctions/SDN-List/Pages/default.aspx
        </a>
        .. You further represent that your access and use of the Protocol will
        fully comply with all applicable laws and regulations, and that you will
        not access or use the Protocol to conduct, promote, or otherwise
        facilitate any illegal activity.&nbsp; If the user is an organization,
        you affirm you have the right, power and authority to enter into this
        agreement on behalf of the organization and bind the organization to its
        terms.
      </p>
      <p>
        Without limiting the foregoing, by using the Protocol, you acknowledge
        and understand that laws regarding financial instruments, which
        sometimes include cryptographic tokens, also known as “Digital
        Currency”, and decentralized finance may vary from jurisdiction to
        jurisdiction, and it is your obligation alone to ensure that you fully
        comply with any law, regulation or directive, relevant to your
        jurisdiction with regard to the use of the Protocol. You further
        represent and warrant that you will not use the Protocol or access its
        smart contract functionality if the laws of your country of residency or
        establishment prohibit you from doing so in accordance with this
        agreement.&nbsp; For the avoidance of doubt, the ability to access the
        Protocol does not necessarily mean that the Protocol, or your activities
        through it, are legal under the laws, regulations or directives relevant
        to your jurisdiction. The Protocol or the services made available
        through the Protocol may not be available to all users, and we reserve
        the right to assess or reassess at any time your eligibility to use all
        or part of our Protocol. The availability of the Protocol does not
        constitute, and may not be used for the purposes of, an offer or
        solicitation to anyone in any jurisdiction in which such offer or
        solicitation is not authorized, or to any person to whom it is unlawful
        to make such an offer or solicitation.&nbsp; By accessing or using the
        Protocol, you explicitly agree that the smart contracts built into the
        Dapps that comprise the Protocol are legally binding and enforceable
        upon you and the contract counterparty.
      </p>
      <p>
        In connection with your use of the Protocol, you agree to bear all costs
        necessary to conduct a transaction, such as "gas" cost on the Ethereum
        network, for the computational resources required to perform a
        transaction on the particular blockchain. We will try to provide you
        with the accurate estimates of these charges for your information, but
        this information is highly volatile and can change quickly and we cannot
        and do not guarantee the accuracy, stability, availability of this
        information. You specifically acknowledge and agree that we have no
        control over: (a) any blockchain transactions; (b) the calculation or
        method of payment of any gas charges; or (c) any actual payments of gas
        charges or such similar charges as implemented by other blockchains. You
        must ensure that you have a sufficient balance of Ether stored at your
        Ethereum Address to complete any transaction on the Ethereum blockchain
        before initiating such Ethereum blockchain transaction.&nbsp; You may be
        subject to additional fees and charges, including fees required to
        access certain smart contracts.&nbsp; You acknowledge that such fees may
        be adjusted from time to time by us or by other users who set the terms
        of their own smart contracts.&nbsp; If you do not agree with the fees
        charged for Network functionality, do not use or access the Network.
      </p>
      <h3>
        <strong>3.&nbsp; Access and Security</strong>
      </h3>
      <p>
        To access the Protocol or some of the resources it offers, you may be
        asked to provide an Ethereum wallet address (a “<strong>Wallet</strong>
        ”). It is your sole responsibility to maintain the security of your
        Wallet. If you lose access to your Wallet, a private key, password, or
        other method of securing your Wallet, any funds may be irretrievable,
        and we will be unable to assist you in any way. You hereby irrevocably
        waive, release and discharge all claims, whether known or unknown to
        you, against us, our affiliates and their officers, employees, agents
        and representatives related to your use of any Wallet software,
        associated loss of funds, transaction failures, or any other defects
        that arise in the course of your use of your Wallet, including any
        losses that may obtain as a result of any failure in smart contracts
        made available on the Protocol.&nbsp; By using the Protocol, you agree
        to be fully, independently and personally liable for each transaction
        made on the Protocol by you, and you must make sure that you are the
        only person with access to your Wallet at all times.&nbsp; You hereby
        accept responsibility for any activity transacted on the Protocol
        through your Wallet.
      </p>
      <p>
        We will use commercially reasonable technical and physical safeguards to
        make the Protocol securely available to its users.&nbsp; However, given
        the inherent risk of transmitting information over the internet and the
        relatively new and untested nature of decentralized finance, we will not
        be liable if for any reason all or any part of the Protocol is
        unavailable at any time or for any period. You alone are responsible for
        evaluating any code provided by or used on the Protocol.&nbsp; From time
        to time, we may restrict access to some parts of the Protocol, or the
        entire Protocol, to users.&nbsp; You are responsible for making all
        arrangements necessary for you to have access to the Protocol and
        ensuring that all persons who access the Protocol through your internet
        connection are aware of these Terms of Use and comply with them.
      </p>
      <p>
        It is a condition of your use of the Protocol that all the information
        you provide on the Protocol is correct, current and complete. You agree
        that all information you provide to this Protocol or otherwise,
        including but not limited to through the use of any interactive features
        on the Protocol, is governed by our{" "}
        <a href="/privacy">Privacy Policy</a>, and you consent to all actions we
        take with respect to your information consistent with our Privacy
        Policy.
      </p>
      <h3>
        <strong>
          4. Intellectual Proprietary Rights &amp; Non-fungible Tokens (NFTS)
        </strong>
      </h3>
      <p>
        <strong>I. Intellectual Property</strong>
      </p>
      <p>
        We own all Intellectual Property and other rights in the Interface and
        its contents, including (but not limited to) software, text, images,
        trademarks, service marks, copyrights, patents, and designs. Unless
        expressly authorized by us, you may not copy, modify, adapt, rent,
        license, sell, publish, distribute, or otherwise permit any third party
        to access or use the Protocol or any of its contents. Provided that you
        are eligible and contingent upon your compliance with these Terms, you
        are hereby granted a personal, worldwide, revocable, non-exclusive and
        non-assignable license to access and use the Interface. This license is
        non-transferable, and freely revocable by us at any time without notice
        or cause. Use of the Protocol or its contents for any purpose not
        expressly permitted by this Agreement is strictly prohibited. Unlike the
        Interface, the Protocol is comprised entirely of open-source software
        running on the public Ethereum blockchain and is not our proprietary
        property.
      </p>
      <p>
        We may use and share your feedback. Any comments, bug reports, ideas, or
        other feedback that you may provide about our Services, including
        suggestions about how we might improve our Services, are entirely
        voluntary. You agree that we are free to use or not use any feedback
        that we receive from you as we see fit, including copying and sharing
        such feedback with third parties, without any obligation to you.
      </p>
      <p>
        &zwj;<strong>II. Additional Rights</strong>
      </p>
      <p>
        We reserve the following rights, which do not constitute obligations of
        ours: (a) with or without notice to you, to modify, substitute,
        eliminate or add to the Protocol; (b) to review, modify, filter,
        disable, delete and remove any and all content and information from the
        Protocol; and (c) to cooperate with any law enforcement, court or
        government investigation or order or third party requesting or directing
        that we disclose information or content or information that you provide.
        <br />
        <br />
        <strong>III. Token</strong>
      </p>
      <p>
        HFT is a cryptographic governance token used in the Protocol and its
        underlying software, which is an autonomous system of smart contracts on
        the Ethereum Blockchain, that governs, among other things, the growth
        and operation of the Protocol. HFT token holders may use their HFTs to
        collectively govern certain rules of use of the Protocol, including
        participation in voting over some key aspects of the Protocol and the
        Hashflow project generally (the “<strong>Voting</strong>
        ”). Any HFT token holder may participate in any Voting by independently
        interacting with the relevant smart contracts within the Protocol (the
        “V<strong>oting Contracts</strong>
        ”). Some members and developers of the Protocol community and its
        underlying software (collectively the “<strong>DAO</strong>
        ”) have provided you with a user interface to facilitate governance of
        the Protocol, including the one available at Gov.Hashflow.com and via
        other tools (the “<strong>Site</strong>
        ”) — which includes text, images, audio, code and other materials
        (collectively, the “<strong>Content</strong>
        ”) and all of the associated features, and services.&nbsp; You
        acknowledge that the DAO &nbsp;may make decisions that affect the
        Services or other programs offered by the Protocol including but not
        limited to access to Tokens, functionality of the Tokens, and
        functionality of the Protocol.&nbsp; You agree to waive all claims
        against us you may have due to actions taken by the DAO.
      </p>
      <p>
        <strong>Token Claiming Policy</strong>
      </p>
      <p>
        It is our policy and you agree that, with regards to the tokens, it is
        in the best interest of the protocol that tokens do not remain
        unclaimed.&nbsp; As such, if you (i) do not follow all procedures
        outlined by us for the claiming of tokens, or (ii) fail to claim tokens
        that are available for you to claim for a period of thirty (30) days,
        unless affirmatively waived by us, such tokens shall revert back to us.
      </p>
      <p>
        Tokens can be claimed by following the procedures outlined on our
        Interface or through instructions provided by us. The procedures for
        claiming tokens may change from time to time, and you are responsible
        for staying up-to-date on the latest procedures. If you fail to follow
        the procedures for claiming tokens, your tokens shall be forfeited. We
        may, although we are not obligated to, in our sole discretion, waive the
        token claiming policy in certain circumstances.
      </p>
      <p>
        &zwj;
        <br />
      </p>
      <p>
        <strong>IV. NFTs</strong>
        <br />
      </p>
      <p>
        A. We grant, to the party who Owns an NFT we have issued for the time
        that party Owns the NFT (“<strong>NFT License Term</strong>
        ”), a license with respect to the Art associated with the NFT purchase,
        subject always to these NFT Terms in force at the date of sale or
        transfer together with any other terms and conditions which may apply to
        the NFT.
      </p>
      <p>
        B. The NFT license is assignable, transferable and revocable, and is for
        your personal, non-commercial, royalty free use of the NFT (including to
        sell or transfer on a Marketplace) and to display and enjoy the Art
        associated with the NFT anywhere in the world (“
        <strong>NFT License</strong>
        ”).
      </p>
      <p>
        C. Upon your sale of the NFT you Own, the License transfers to the
        purchaser who then Owns the NFT and will be subject to the NFT License
        and these NFT Terms. For the avoidance of doubt, the transfer of the NFT
        License does not constitute a commercial use for the purposes of clause
        B.
      </p>
      <p>
        D. With immediate effect upon your sale of the NFT you Own, your rights
        under the NFT License pursuant to clause B shall terminate. You will no
        longer be entitled to use the Art (or any reproductions of the Art) upon
        sale by you of the NFT.
      </p>
      <p>
        E. Except as expressly stated in these NFT Terms, nothing in these NFT
        Terms are intended to, or shall operate to, give you ownership of any
        Intellectual Property rights in, or other rights with respect to the
        Intellectual Property.
      </p>
      <p>
        F. There is no transfer of title or ownership of any Intellectual
        Property or any Intellectual Property rights upon the sale of the NFT
        under these NFT Terms.
      </p>
      <p>G. The NFT may not be used in any way which would:</p>
      <ol>
        <li>modify any Art; or</li>
        <li>
          use the Art to market or to sell third-party products or for any other
          commercial benefit; or
        </li>
        <li>
          use the Art in connection with images of hatred, violence or other
          inappropriate behavior that could be reasonably considered to bring
          the Intellectual Property rights owner into disrepute; or
        </li>
        <li>
          seek to trademark or acquire Intellectual Property rights in the Art;
          or
        </li>
        <li>
          take, appropriate or represent any ownership in the Intellectual
          Property; or
        </li>
        <li>
          assert any right to or over the Intellectual Property in any manner
          inconsistent with the rights under these NFT Terms; or
        </li>
        <li>
          take any action which would or might invalidate, challenge, oppose or
          otherwise put in dispute the owner’s rights to the Intellectual
          Property; or be reasonably seen to disparage the Intellectual Property
          rights of the owner; or
        </li>
        <li>
          contravene the moral rights of the artist or licensor of the Art; or
        </li>
        <li>contravene the Terms or these NFT Terms; or</li>
        <li>
          cause, permit or assist any other person directly or indirectly to do
          any of the above acts.
        </li>
      </ol>
      <p>H. For the avoidance of any doubt:</p>
      <ol>
        <li>
          the restrictions on the NFT License survive termination or assignment
          transfer of the NFT License; and&nbsp;
        </li>
        <li>
          the purchase of an NFT does not grant you any ownership or license for
          any Intellectual Property rights over Hashflow or any aspect of Art
          used in our NFTs other than as expressly stated in these NFT Terms;
          and&nbsp;
        </li>
        <li>
          the NFT License granted under this clause is limited to the time you
          Own the NFT and upon your sale of the NFT to another party the NFT
          License is assigned to the purchaser of the NFT and your rights under
          the License terminate, and you must draw to the other party’s
          attention the contents of these NFT Terms prior to your sale of the
          NFT;
        </li>
        <li>
          the sale of your NFT does not constitute a “commercial use” of your
          NFT for the purposes of these NFT Terms.
        </li>
      </ol>
      <p>I. Termination</p>
      <ol>
        <li>
          These NFT Terms and the NFT License may be terminated with immediate
          effect:
          <br />
          a) by us if any of the warranties in clause K are breached; or
          <br />
          b) by us if the limitations of the NFT License are breached; or
          <br />
          c) by either party if the other party commits any material breach of
          its obligations under these Terms and fails to remedy such breach (if
          capable of remedy) within 30 days of receipt of notice from the
          non-defaulting party requiring it to do so.
        </li>
        <li>
          Termination of these NFT Terms does not affect the rights of the
          parties which have accrued prior to termination.
        </li>
      </ol>
      <p>J. Acknowledgements.&nbsp;</p>
      <p>You acknowledge and agree that:</p>
      <ol>
        <li>
          we provide NFTs solely on a proprietary basis for use with Hashflow
          and if we transact with you we do so solely on a bilateral basis;
        </li>
        <li>
          NFTs are not intended for speculative use, are not sold or represented
          to be financial product and nothing we publish is in any way financial
          advice to you or any other person;
        </li>
        <li>
          NFTs may experience or may have extreme price volatility, including
          being worthless in the future;
        </li>
        <li>
          we are not providing and will not provide any fiduciary, advisory,
          brokerage, exchange or other similar services to you or any other
          person;
        </li>
        <li>
          you are solely responsible for any decision to enter into a
          transaction subject to these NFT Terms, including the evaluation of
          any and all risks related to any such transaction;
        </li>
        <li>
          a significant degree of sophistication is required to safely deal in
          and store NFTs of any kind using a Digital Wallet;
        </li>
        <li>
          we are not a custodian for the purposes of the Corporations Act, and
          transfers of any NFTs are for transaction purposes only;
        </li>
        <li>
          we are not responsible for any Loss caused by your failure to act in
          accordance with our policies, procedures or in accordance with our
          reasonable directions;
        </li>
        <li>
          you purchase NFTs entirely at your own risk and understanding and we
          have not made any representations or warranties as to the IT security
          or ongoing availability of such NFTs or that your access to use your
          NFTs in Hashflow or in any other way will be uninterrupted, timely or
          secure at all time
        </li>
        <li>
          you understand and acknowledge that your ownership of NFTs remains
          contingent upon you remaining in control of the seed phrases and
          private key(s) associated with your Digital Wallet and that we will
          not store any information in connection with your Digital Wallet
          beyond that required for the sale of NFTs or the interaction of your
          Digital Wallet with Hashflow;
        </li>
        <li>
          we do not and cannot guarantee there will be any use for, or any
          particular price available for any NFT you purchase from us; and
        </li>
        <li>
          we do not represent or guarantee any outcomes, or any financial return
          from your acquisition of any NFT from us, save the ability to use the
          NFT within Hashflow for such time as we choose to support on and off
          Hashflow, and such access to Hashflow may be subject to further terms
          and conditions, including payment of subscription fees.
        </li>
        <li>
          You must disclose to us anything that has or will constitute a
          material breach of a Warranty in these Terms or cause a Warranty in
          these Terms to be untrue or inaccurate, as soon as practicable after
          you become aware of it.
        </li>
      </ol>
      <p>
        5.&nbsp; <strong>Warranties</strong>
        <br />
      </p>
      <p>
        <em>Your Warranties</em>
      </p>
      <p>
        You warrant and assure us that in acquiring an NFT (from us or from a
        third party or existing NFT holder):
        <br />
      </p>
      <ol>
        <li>
          You are sufficiently experienced and educated to make decisions
          regarding the use of the Protocol and the procurement or purchase of
          NFTs from us, including sufficient experience in dealing with and
          storing NFTs using a Digital Wallet;
        </li>
        <li>
          You have all necessary experience, resources, certificates, licenses,
          permits and approvals to interact with the Protocol and procure or
          purchase of NFTs applicable in Your Jurisdiction, and that any
          transactions under these NFT Terms or in your use of Hashflow will be
          legal under the applicable laws of Your Jurisdiction;
        </li>
        <li>
          All information you supply to us is true and accurate as at the time
          it is given, and that any Digital Wallet address you provide to us has
          been generated in accordance with best practice security measures and
          no other party, other than you or your authorized representative, has
          used, or has access to, the seed phrases, private keys or analogous
          passwords required to effect transfers from, the Digital Wallet;&nbsp;
        </li>
        <li>
          as far as you are aware, there are no facts, circumstances or other
          information which both:
          <br />
          a) you have not fully and fairly disclosed to us in a manner and to an
          extent that it would impact our ability to make a reasonable
          assessment of those facts, matters and circumstances prior to entering
          into a transaction to sell you an NFT; and
          <br />
          b) is of such nature and materiality that a reasonable person, had it
          been made aware of, could not reasonably be expected to consider prior
          to entering into a transaction for the sale of NFTs;
        </li>
        <li>
          You are not involved in any capacity in any claim, legal action,
          proceeding, suit, litigation, prosecution, investigation, inquiry,
          mediation or arbitration (nor which are pending or threatened)
          concerning the purchase and sale of cryptographic tokens or NFTs;
        </li>
        <li>
          If we request, you will identify and substantiate the source of funds
          involved in transactions to acquire NFTs;
        </li>
        <li>
          No Digital Currency transferred to us as part of a Purchase Price has
          been derived from any illegal or unlawful activity;
        </li>
        <li>
          You are the lawful owner of any Digital Wallet nominated for delivery
          of NFTs and each Digital Wallet is owned and operated solely for your
          benefit, and no person has any right, title or interest in your
          nominated Digital Wallet; and
        </li>
        <li>
          You have had the opportunity to obtain independent legal advice in
          relation to the terms and effect of these Terms.
        </li>
        <li>
          that each of the Warranties in this section is true and accurate, and
          not misleading or deceptive as at the date of these Terms.
        </li>
      </ol>
      <p>
        <br />
      </p>
      <p>
        <strong>Disclaimer of Warranties</strong>
        <br />
      </p>
      <p>
        WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED
        DENIAL-OF-SERVICE ATTACK, HACKS, VIRUSES OR OTHER TECHNOLOGICALLY
        HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER
        PROGRAMS, DATA OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE
        PROTOCOL OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE PROTOCOL, ANY
        THIRD PARTY LINKS (INCLUDING BUT NOT LIMITED TO SMART CONTRACTS FAQS OR
        OTHER MATERIALS) ACCESSED THROUGH OR IN CONJUNCTION WITH THE PROTOCOL,
        OR ON ANY APPS LINKED TO IT.&nbsp; YOUR USE OF THE PROTOCOL, ITS CONTENT
        AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE PROTOCOL IS AT YOUR OWN
        RISK. THE PROTOCOL, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED
        THROUGH THE PROTOCOL ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE"
        BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
        NEITHER THE FOUNDATION, THE DAO NOR ANY PERSON ASSOCIATED WITH THEM
        MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS,
        SECURITY, RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE
        PROTOCOL. WITHOUT LIMITING THE FOREGOING, NEITHER THE COMPANY NOR ANYONE
        ASSOCIATED WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE PROTOCOL,
        ITS CONTENT OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE NETWORK WILL
        BE ACCURATE, RELIABLE, ERROR-FREE OR UNINTERRUPTED, THAT DEFECTS WILL BE
        CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE
        OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE PROTOCOL OR ANY
        SERVICES OR ITEMS OBTAINED THROUGH THE PROTOCOL WILL OTHERWISE MEET YOUR
        NEEDS OR EXPECTATIONS.&nbsp;
      </p>
      <p>
        YOU HEREBY IRREVOCABLY WAIVE, RELEASE AND DISCHARGE ALL CLAIMS, WHETHER
        KNOWN OR UNKNOWN TO YOU, AGAINST US, OUR AFFILIATES AND THEIR RESPECTIVE
        SHAREHOLDERS, MEMBERS, DIRECTORS, OFFICERS, EMPLOYEES, AGENTS AND
        REPRESENTATIVES RELATED TO YOUR USE OF ANY WALLET SOFTWARE, ASSOCIATED
        LOSS OF FUNDS, TRANSACTION FAILURES, OR ANY OTHER DEFECTS THAT ARISE IN
        THE COURSE OF YOUR USE OF YOUR WALLET<strong>.&nbsp; </strong>
        THE COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS
        OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY
        WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR
        PARTICULAR PURPOSE.&nbsp;&nbsp;
      </p>
      <p>
        THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR
        LIMITED UNDER APPLICABLE LAW.
        <br />
      </p>
      <h3>
        <strong>6.&nbsp; Release of Claims</strong>
      </h3>
      <p>
        You acknowledge that the <strong>Protocol</strong>
        (including without limitation the smart contracts) and your use of the{" "}
        <strong>Protocol</strong>
        contain certain risks, including without limitation the following risks:
        &nbsp;any smart contracts you interact with are entirely your own
        responsibility and your own liability, and we are not a party to the
        smart contracts; At any time, your access to your Digital Assets may be
        suspended or terminated or there may be a delay in your access or use of
        your Digital Assets which may result in the Digital Assets diminishing
        in value or you being unable to complete a smart contract; if your
        collateral declines such that your collateral is no longer sufficient to
        secure your position as a signer or depositor that a liquidation auction
        may not produce sufficient revenue to return your collateral, or other
        users may seize your collateral to close out your account; and the{" "}
        <strong>Protocol</strong>
        and related smart contracts may be suspended or terminated for any or no
        reason, which may limit your access to your Digital Assets.&nbsp; You
        assume all risk in connection with your access to and use of the{" "}
        <strong>Protocol</strong>
        and its smart contracts, and you waive and release us from any and all
        liability, claims, causes of action or damages arising from or in any
        way related to your use of the <strong>Protocol</strong>
        or the smart contracts.
      </p>
      <h3>
        <strong>7. Privacy</strong>
      </h3>
      <p>
        The information we collect from you and how we use it are described in
        our privacy policy located at{" "}
        <a href="/privacy">hashflow.com/privacy</a>
        .&nbsp; When you use the Interface, the only information we collect from
        you is your blockchain wallet address, completed transaction hashes, and
        the token names, symbols, or other blockchain identifiers of the tokens
        that you swap. We do not collect any personal information from you
        (e.g., your name or other identifiers that can be linked to you). We
        may, however, use third-party service providers, like Infura,
        Cloudflare, and Google Analytics, which may receive or independently
        obtain your personal information from publicly-available sources. We do
        not control how these third parties handle your data and you should
        review their privacy policies to understand how they collect, use, and
        share your personal information. In particular, please visit{" "}
        <a href="https://policies.google.com/technologies/partner-sites">
          https://policies.google.com/technologies/partner-sites
        </a>
        to learn more about how Google uses data. By accessing and using the
        Protocol, you understand and consent to our data practices and our
        service providers' treatment of your information.
        <br />
        <br />
        We use the information we collect to detect, prevent, and mitigate
        financial crime and other illicit or harmful activities on the
        Interface. For these purposes, we may share the information we collect
        with blockchain analytics providers. We share information with these
        service providers only so that they can help us promote the safety,
        security, and integrity of the Interface. We do not retain the
        information we collect any longer than necessary for these purposes.
        <br />
        <br />
        Please note that when you use the Interface, you are interacting with
        the Ethereum blockchain, which provides transparency into your
        transactions. Hashflow does not control and is not responsible for any
        information you make public on the Ethereum blockchain by taking actions
        through the Interface.
      </p>
      <p>
        We care about your privacy. Although we will comply with all valid
        subpoena requests, we will carefully consider each request to ensure
        that it comports with the spirit and letter of the law, and we will not
        hesitate to challenge invalid, overbroad, or unconstitutional requests
        as appropriate. We use commercially reasonable safeguards to preserve
        the integrity and security of your personally identifiable information
        (“PII”) and aggregate data. However, we cannot guarantee that
        unauthorized third parties will never be able to obtain or use your PII
        or aggregate data for improper purposes. You acknowledge that you
        provide your PII and aggregate data at your own risk. By accessing and
        using the Interface, you understand and consent to our collection, use,
        and disclosure of your PII and aggregate data as per our Privacy Policy.
      </p>
      <h3>
        <strong>8.&nbsp; Prohibited Activity</strong>
      </h3>
      <h6>
        You agree not to engage in, or attempt to engage in, any of the
        following categories of prohibited activity in relation to your access
        and use of the Protocol:
      </h6>
      <ul>
        <li>
          <em>
            Intellectual Property Infringement. Activity that infringes on or
            violates any copyright, trademark, service mark, patent, right of
            publicity, right of privacy, or other proprietary or intellectual
            property rights under the law.
          </em>
        </li>
        <li>
          <em>
            Cyberattack. Activity that seeks to interfere with or compromise the
            integrity, security, or proper functioning of any computer, server,
            network, personal device, or other information technology system,
            including (but not limited to) the deployment of viruses and denial
            of service attacks.
          </em>
        </li>
        <li>
          <em>
            Theft, Fraud and Misrepresentation. Activity that (i) seeks to
            defraud us or any other person or entity, including (but not limited
            to) providing any false, inaccurate, or misleading information in
            order to unlawfully obtain the property of another or (ii) seeks to
            unlawfully take another person's personal property with the intent
            of depriving that person of the use of their property.
          </em>
        </li>
        <li>
          <em>
            Market Manipulation. Activity that violates any applicable law,
            rule, or regulation concerning the integrity of trading markets,
            including (but not limited to) the manipulative tactics commonly
            known as spoofing and wash trading.
          </em>
        </li>
        <li>The promotion of any illegal activity or unlawful acts.</li>
        <li>
          The posting of material which is defamatory, obscene, indecent,
          abusive, offensive harassing, violent, hateful, inflammatory or
          otherwise objectionable.<em>&zwj;</em>
        </li>
        <li>
          <em>
            Any Other Unlawful Conduct. Activity that violates any applicable
            law, rule, or regulation of the United States or another relevant
            jurisdiction, including (but not limited to) the restrictions and
            regulatory requirements imposed by U.S. law.
          </em>
        </li>
      </ul>
      <p>
        <strong>Not Registered with the SEC or Any Other Agency</strong>
        <br />
      </p>
      <p>
        We are not registered with the U.S. Securities and Exchange Commission
        as a national securities exchange or in any other capacity. You
        understand and acknowledge that we do not broker trading orders on your
        behalf nor do we collect or earn fees from your trades on the Protocol.
        We also do not facilitate the execution or settlement of your trades,
        which occur entirely on a public distributed blockchain.
      </p>
      <h3>
        <strong>9. No Professional Advice</strong>
      </h3>
      <p>
        All information provided by the Protocol is for informational purposes
        only and should not be construed as professional advice. You should not
        take, or refrain from taking, any action based on any information
        contained in the Protocol. Before you make any financial, legal, or
        other decisions involving the Protocol, you should seek independent
        professional advice from an individual who is licensed and qualified in
        the area for which such advice would be appropriate.
      </p>
      <h3>
        <strong>10. Staking Products</strong>
      </h3>
      <p>
        Market Makers using Hashflow may offer an opportunity for third parties
        to contribute funds into pools managed by the Market Maker so that the
        third party may benefit from the market making strategies employed by
        the applicable Market Maker (“Public Pools”).&nbsp; In such case, the
        Market Maker may offer a return on the amount of funds staked by the
        third party.&nbsp; Hashflow does not endorse or guarantee any return
        advertised by Market Makers offering Public Pools.&nbsp; Market Makers
        offering this service acknowledge and agree that they are solely
        responsible for any obligations or representations made to any third
        party that contributes to a Market Maker’s Public Pool.&nbsp; You can
        learn more about how Public Pools work on Hashflow by visiting
        https://app.hashflow.com/pools.&nbsp; Note, the price used as a basis
        for the HFT APY was determined in our discretion and may not reflect
        current market conditions or the actual value of HFTs.&nbsp; This APY,
        and its associated terms (such as redemption terms, etc),&nbsp; may be
        adjusted by us in our sole discretion.
      </p>
      <p>
        BY USING THIS APP YOU ACKNOWLEDGE THE FOLLOWING: WE ARE NOT INVESTMENT
        ADVISORS, AND THE INFORMATION WE PROVIDE IS NOT INVESTMENT ADVICE.&nbsp;
        THE STAKING AND TRADING OF CRYPTOGRAPHIC TOKENS CARRIES SIGNIFICANT
        RISK, AND YOU COULD LOSE SOME OR ALL OF YOUR CRYPTOCURRENCY.&nbsp; YOU
        ARE RESPONSIBLE FOR ALL STAKING DECISIONS. THE APP MAY OFFER ACCESS TO
        STAKING OPPORTUNITIES THAT ARE SPONSORED BY US, BY THIRD PARTIES, OR BY
        THIRD PARTIES IN CONCERT WITH US.&nbsp; SUCH PROTOCOLS MAY OFFER STAKING
        REWARDS IN THE FORM OF STAKED TOKENS OR REWARD TOKENS AFFILIATED WITH
        THEIR PROTOCOLS. &nbsp; SUCH REWARDS MAY BE PAID BY THE APPLICABLE
        OFFERING PARTIES OR BY US FOR PARTICIPATING IN THE PROGRAM.&nbsp; NO
        STAKING REWARDS ARE GUARANTEED, AND ANY RETURNS, OFTEN REFERRED TO AS
        ANNUAL PERCENTAGE YIELD OR APY, ARE ESTIMATES THAT MIGHT PROVE
        INCORRECT. &nbsp; THE REWARDS YOU EARN, IF ANY, ARE BASED ON THE STAKING
        DECISIONS YOU MAKE.&nbsp; CRYPTOCURRENCY MARKETS ARE EXPERIMENTAL AND
        EXTREMELY VOLATILE.&nbsp; DO NOT STAKE ANY FUNDS YOU CANNOT AFFORD TO
        LOSE.&nbsp; ALL RETURNS ARE SUBJECT TO MARKET FLUCTUATIONS AND MAY NOT
        ACTUALLY BE REALIZED.&nbsp; ALL STAKING ACTIVITY IS COVERED BY THIS
        DISCLAIMER AND THE RULES OF THE STAKING PROGRAM.
      </p>
      <h3>
        <strong>
          11. Non-Custodial and No Fiduciary Duties and Affiliate Transactions
        </strong>
      </h3>
      <p>
        As has been stated earlier, the Protocol is a purely non-custodial
        application, meaning you are solely responsible for the custody of the
        cryptographic private keys to the digital asset wallets you hold. You
        understand and agree that we do not custody, control or manage user
        funds in any manner whatsoever. The Protocol enables access to an
        online, decentralized and autonomous protocol and environment, and
        associated decentralized networks, that are not controlled by us. We do
        not have access to your private key and cannot initiate a transfer of
        cryptocurrency or otherwise access your digital assets. We are not
        responsible for any activities that you engage in when using your
        wallet, or the Protocol.
      </p>
      <p>
        This Agreement is not intended to, and does not, create or impose any
        fiduciary duties on us. To the fullest extent permitted by law, you
        acknowledge and agree that we owe no fiduciary duties or liabilities to
        you or any other party, and that to the extent any such duties or
        liabilities may exist at law or in equity, those duties and liabilities
        are hereby irrevocably disclaimed, waived, and eliminated. You further
        agree that the only duties and obligations that we owe you are those set
        out expressly in this Agreement.
      </p>
      <p>
        Finally, you acknowledge that we may provide services through the
        Protocol from an entity that is affiliated with us.&nbsp; Services may
        include the provision of digital assets through the market making of
        such assets.&nbsp; You expressly agree to waive any and all claims you
        may have against us for actions taken by such affiliated entity or
        entities.&nbsp; Any disputes or claims you may have relating to your
        interactions with an applicable affiliated entity shall be brought
        solely against that entity under the terms of your arrangement,
        contractual or otherwise, with that entity.
      </p>
      <h3>
        <strong>12. Compliance Obligations</strong>
      </h3>
      <p>
        The Protocol is operated from facilities outside of the United States.
        The Protocol may not be available or appropriate for use in certain
        jurisdictions as determined by us. By accessing or using the Protocol,
        you agree that you are solely and entirely responsible for compliance
        with all laws and regulations that may apply to you. You may not use the
        Protocol if you are a citizen, resident, or member of any jurisdiction
        or group that is subject to economic sanctions by any governmental
        authority, or if your use of the Protocol would be illegal or otherwise
        violate any applicable law. The Protocol and all of its contents are
        solely directed to individuals, companies, and other entities located
        outside of the United States.
      </p>
      <h3>
        <strong>13. Assumption of Risk</strong>
      </h3>
      <p>
        By accessing and using the Protocol, you represent that you are
        financially and technically sophisticated enough to understand the
        inherent risks associated with using cryptographic and blockchain-based
        systems, and that you have a working knowledge of the usage and
        intricacies of digital assets such as bitcoin (BTC), ether (ETH), and
        other digital tokens such as those following the Ethereum Token Standard
        (ERC-20). In particular, you understand that blockchain-based
        transactions are irreversible and that we do not have possession,
        custody or control over any cryptoassets appearing on the Protocol; and
        we do not have possession, custody, or control over any user’s funds.
        Further, we do not store, send, or receive any cryptoassets.
        <br />
      </p>
      <p>
        You further understand that the markets for these digital assets are
        highly volatile due to factors including (but not limited to) adoption,
        speculation, technology, security, and regulation. You acknowledge that
        the cost and speed of transacting with cryptographic and
        blockchain-based systems (such as Ethereum) are variable and may
        increase dramatically at any time. You further acknowledge the risk that
        your digital assets may lose some or all of their value while they are
        supplied to the Protocol through the Interface, you may suffer loss due
        to the fluctuation of prices of tokens in a trading pair or liquidity
        pool, and, especially in expert modes, experience significant price
        slippage and cost. You understand that anyone can create a token,
        including fake versions of existing tokens and tokens that falsely claim
        to represent projects, and acknowledge and accept the risk that you may
        mistakenly trade those or other tokens. You further acknowledge that we
        are not responsible for any of these variables or risks, do not own or
        control the Protocol, and cannot be held liable for any resulting losses
        that you experience while accessing or using the Protocol. Accordingly,
        you understand and agree to assume full responsibility for all of the
        risks of accessing and using the Protocol and interacting with the
        Protocol.
      </p>
      <p>
        The software underlying blockchain networks on which the Protocol is
        deployed, including, for example, the Ethereum blockchain, is open
        source, which means that anyone can use, utilize, and build on top of
        it. By using the services or the Protocol, you acknowledge and agree (i)
        that we are not responsible for the operation of the blockchain-based
        software and networks underlying the Protocol, (ii) that there exists no
        guarantee of the functionality, security, or availability of that
        software and networks, and (iii) that the underlying blockchain-based
        networks are subject to sudden changes in operating rules, such as those
        commonly referred to as “forks”.&nbsp; Additionally, you acknowledge
        that many if not all transactions on the blockchain are not anonymous.
      </p>
      <h3>
        <strong>14. Third-Party Resources and Promotions</strong>
      </h3>
      <p>
        The Protocol may contain references or links to third-party resources,
        including (but not limited to) information, materials, products, or
        services, that we do not own or control. In addition, third parties may
        offer promotions related to your access and use of the Protocol. We do
        not endorse or assume any responsibility for any such resources or
        promotions. Additional terms and conditions may apply to specific
        portions, services or features of the applications or services provided
        by third parties including Dapps and smart contracts, either alone or in
        conjunction with the functionality provided by us. The use of such
        services or features shall be governed by the terms of use associated
        with them, and we accept no liability or responsibility for any
        third-party functionality or any of our open source functionality that
        has been modified by third parties.&nbsp; If you access any such
        resources or participate in any such promotions, you do so at your own
        risk, and you understand that this Agreement does not apply to your
        dealings or relationships with any third parties. You expressly relieve
        us of any and all liability arising from your use of any such resources
        or participation in any such promotions. Additionally, you acknowledge
        and agree that we are not responsible for the content and availability
        of such external sites, applications or resources. We do not endorse and
        are not responsible or liable for any content, advertising, products or
        other materials on or available from such sites, applications or
        resources. Finally, if you are using the Protocol to supply digital
        assets, or information relating to digital assets including but not
        limited to pricing information, you grant to us a license to use and
        display your name on the Protocol up to and until you cease such
        activities on the Protocol.
      </p>
      <h3>
        <strong>15. Release of Claims</strong>
      </h3>
      <p>
        You expressly agree that you assume all risks in connection with your
        access and use of the Interface and your interaction with the Protocol.
        You further expressly waive and release us from any and all liability,
        claims, causes of action, or damages arising from or in any way relating
        to your use of the Interface and your interaction with the Protocol
        including but not limited to any losses you sustain due to malicious
        cyberattacks or bugs.&nbsp;
      </p>
      <p>
        Additionally, You assume the risks of engaging in transactions that rely
        on smart contracts and other experimental technology.&nbsp; Transactions
        on the Protocol rely on smart contracts stored on various blockchains,
        cryptographic tokens generated by the smart contracts, and other nascent
        software, applications and systems that interact with blockchain-based
        networks. These technologies are experimental, speculative, inherently
        risky, and subject to change. Among other risks, bugs, malfunctions,
        cyberattacks, or changes to the applicable blockchain (e.g., forks)
        could disrupt these technologies and even result in a total loss of
        cryptoassets, their market value, or digital funds. This includes
        interoperability with digital asset wallets that may or may not be
        supported by the Interface.&nbsp; You are solely responsible for the
        safekeeping of the private key associated with the blockchain address
        used to interact with the Protocol. We assume no liability or
        responsibility for any such risks.
        <br />
      </p>
      <p>
        You acknowledge the risks of using any services associated with this
        Agreement (the “Services”).&nbsp; You bear sole responsibility for
        evaluating the Services before using them, and all transactions accessed
        through the Services are irreversible, final, and without refunds. The
        Services may be disabled, disrupted or adversely impacted as a result of
        sophisticated cyber-attacks, surges in activity, computer viruses,
        and/or other operational or technical challenges, among other things. We
        disclaim any ongoing obligation to notify you of all of the potential
        risks of using and accessing our Services. You agree to accept these
        risks and agree that you will not seek to hold any Indemnified Party (as
        defined below) responsible for any consequent losses.
        <br />
      </p>
      <p>
        We do not guarantee the quality or accessibility of the Services.&nbsp;
        As a condition to accessing or using the Services or the Protocol, you
        acknowledge, understand, and agree that from time to time, the App and
        the Services may be inaccessible or inoperable for any reason,
        including, but not limited to equipment malfunctions, periodic
        maintenance procedures or repairs, causes beyond our control or that we
        could not reasonably foresee, disruptions and temporary or permanent
        unavailability of underlying blockchain infrastructure or unavailability
        of third-party service providers or external partners for any reason.
      </p>
      <p>
        You acknowledge and agree that you will access and use the Services,
        including, without limitation, the App at your own risk. You should not
        engage in blockchain-based transactions unless it is suitable given your
        circumstances and financial resources. By using the Services, you
        represent that you have been, are and will be solely responsible for
        conducting your own due diligence into the risks of a transaction and
        the underlying smart contracts and cryptoassets.
        <br />
      </p>
      <p>
        Finally, You are responsible for your taxes and duties. users bear sole
        responsibility for paying any and all taxes, duties, and assessments now
        or hereafter claimed or imposed by any governmental authority associated
        with their use of the Services, and/or payable as the result of using
        and/or exploiting any cryptoassets and interacting with smart contracts.
        Blockchain-based transactions are novel, and their tax treatment is
        uncertain.
      </p>
      <h3>
        <strong>16. Indemnity</strong>
      </h3>
      <p>
        You agree to hold harmless, release, defend, and indemnify the
        Indemnified Parties (as defined below) from and against all claims,
        damages, obligations, losses, liabilities, costs, and expenses arising
        from: (a) your access and use of the Protocol including but not limited
        to your misuse of the Protocol; (b) your violation of any law, any term
        or condition of this Agreement, the rights of any third party, or any
        other applicable law, rule, or regulation; (c) any other party’s access
        and use of the Interface with your assistance or using any device or
        account that you own or control; (d) your fraud or willful misconduct.
      </p>
      <h3>
        <strong>17. Limitation of Liability</strong>
      </h3>
      <p>
        Under no circumstances shall we or any of our officers, directors,
        employees, contractors, agents, affiliates, parents, related companies,
        subsidiaries, representatives, or licensors (collectively, the “
        <strong>Indemnified Parties</strong>
        ”) be liable to you for any indirect, punitive, incidental, special,
        consequential, or exemplary damages, including (but not limited to)
        damages for loss of profits, goodwill, use, data, or other intangible
        property, arising out of or relating to any access or use of the
        Protocol, nor will we be responsible for any damage, loss, or injury
        resulting from hacking, tampering, or other unauthorized access or use
        of the Interface, the Services or the information contained within it.
        We assume no liability or responsibility for any: (a) errors, mistakes,
        or inaccuracies of content; (b) personal injury or property damage, of
        any nature whatsoever, resulting from any access or use of the Protocol
        or the Services; (c) unauthorized access or use of any secure server or
        database in our control, or the use of any information or data stored
        therein; (d) interruption or cessation of function related to the
        Protocol or the Services; (e) bugs, viruses, trojan horses, or the like
        that may be transmitted to or through the Protocol or the Services; (f)
        errors or omissions in, or loss or damage incurred as a result of the
        use of, any content made available through the Protocol or the Services
        ;&nbsp; (g) the defamatory, offensive, or illegal conduct of any third
        party; (h) the actions or inaction of the DAO; and (i) liabilities
        arising from staking activity or your decision to interact with one or
        more Public Pools through the Protocol. Under no circumstances shall we
        or any of our officers, directors, employees, contractors, agents,
        affiliates, or subsidiaries be liable to you for any claims,
        proceedings, liabilities, obligations, damages, losses, or costs in an
        amount exceeding the amount you paid to us in exchange for access to and
        use of the Protocol, or $100.00, whichever is greater. This limitation
        of liability applies regardless of whether the alleged liability is
        based on contract, tort, negligence, strict liability, or any other
        basis, and even if we have been advised of the possibility of such
        liability. This limitation of liability shall apply to the fullest
        extent permitted by law.
      </p>
      <h3>
        <strong>18.&nbsp; Geographic Restrictions</strong>
      </h3>
      <p>
        Access to the Network may not be legal by certain persons or in certain
        countries. You are responsible for compliance with all applicable laws
        in your jurisdiction.
      </p>
      <h3>
        <strong>19. Dispute Resolution</strong>
      </h3>
      <p>
        We will use our best efforts to resolve any potential disputes through
        informal, good faith negotiations. If a potential dispute arises, you
        must contact us by sending an email to legal@hashflow.com so that we can
        attempt to resolve it without resorting to formal dispute resolution. If
        we aren’t able to reach an informal resolution within sixty days of your
        email, then you and we both agree to resolve the potential dispute
        according to the process set forth below.
      </p>
      <p>
        Any claim or controversy arising out of or relating to the Protocol,
        this Agreement, or any other acts or omissions for which you may contend
        that we are liable, including (but not limited to) any claim or
        controversy as to arbitrability (“Dispute”), shall be finally and
        exclusively settled by arbitration under the JAMS Optional Expedited
        Arbitration Procedures. You understand that you are required to resolve
        all Disputes by binding arbitration. The arbitration shall be held on a
        confidential basis before a single arbitrator, who shall be selected
        pursuant to JAMS rules. The arbitration will be held in San Francisco,
        California, unless you and we both agree to hold it elsewhere. Unless we
        agree otherwise, the arbitrator may not consolidate your claims with
        those of any other party. Any judgment on the award rendered by the
        arbitrator may be entered in any court of competent jurisdiction.
      </p>
      <h3>
        <strong>20. Class Action and Jury Trial Waiver</strong>
      </h3>
      <p>
        You must bring any and all Disputes against us in your individual
        capacity and not as a plaintiff in or member of any purported class
        action, collective action, private attorney general action, or other
        representative proceeding. This provision applies to class arbitration.
        You and we both agree to waive the right to demand a trial by jury.
      </p>
      <h3>
        <strong>21. Governing Law</strong>
      </h3>
      <p>
        <strong>
          <em>
            This Agreement shall be governed by and construed in accordance with
            the laws of the Cayman Islands. Any and all disputes arising out of
            or in connection with this Agreement, including any question
            regarding its existence, validity, or termination, shall be resolved
            by arbitration in accordance with the rules of the International
            Chamber of Commerce. The place of arbitration shall be the state of
            California, USA. The language of the arbitration shall be English.
            The parties agree to abide by and perform any award rendered by the
            arbitrator(s). Judgment upon the award rendered by the arbitrator(s)
            may be entered in any court having jurisdiction thereof.
          </em>
        </strong>
      </p>
      <h3>
        <strong>22. Entire Agreement</strong>
      </h3>
      <p>
        These Terms (and any additional terms, rules and conditions of
        participation that may be posted on the App) constitute the entire
        agreement with respect to the Protocol and supersedes any prior
        agreements, oral or written.
      </p>
      <h3>
        <strong>23. Survival</strong>
      </h3>
      <p>
        Upon termination of these Terms for any reason, all rights and
        obligations of the parties that by their nature are continuing will
        survive such termination.
      </p>
      <p>&zwj;</p>
    </div>
  );
};
